<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Change Job Priority</h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <form name="jobForm" [formGroup]="jobForm">
    <mat-form-field appearance="fill">
      <mat-label>Select Priority</mat-label>
      <mat-select formControlName="job_Priority" required>
        <mat-option *ngFor="let priority of priorities" [value]="priority">
          {{ priority }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          jobForm.get('job_Priority').touched &&
          jobForm.get('job_Priority').errors
        "
        >Please Select Priority.</mat-error
      >
    </mat-form-field>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit(jobForm)"
    cdkFocusInitial
  >
    Submit
  </button>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default" zIndex = "1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="jobPriority"
  ></ngx-spinner
>
